import React from "react";
import {useSelector} from "react-redux";

const DownloadAdmissionDocumentPdf = ({doc, extraClass = ''}) => {
    const idToken = useSelector(state => state.auth.idToken);
    console.log('[DownloadAdmissionDocumentPdf]', doc)

    const handleDownload = () => {
        // https://stackoverflow.com/questions/29452031/how-to-handle-file-downloads-with-jwt-based-authentication

        let anchor = document.createElement("a");
        document.body.appendChild(anchor);
        let fileApiPath = `${process.env.REACT_APP_API_PATH}/admission/document/${doc.id}/download-pdf`;
        let headers = new Headers();
        headers.append('Authorization', idToken);

        fetch(fileApiPath, {headers})
            .then(response => {
                const disposition = response.headers.get('Content-Disposition') || '';
                let filename = doc.title + '.pdf';
                // Try RFC 5987 filename* first, then plain filename=
                const starMatch = disposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
                const plainMatch = disposition.match(/filename="?([^";]+)"?/i);
                if (starMatch && starMatch[1]) {
                    try { filename = decodeURIComponent(starMatch[1].trim()); } catch (e) { /* keep fallback */ }
                } else if (plainMatch && plainMatch[1]) {
                    filename = plainMatch[1].trim();
                }
                return response.blob().then(blobby => ({blobby, filename}));
            })
            .then(({blobby, filename}) => {
                let objectUrl = window.URL.createObjectURL(blobby);

                anchor.href = objectUrl;
                anchor.download = filename;
                anchor.click();

                window.URL.revokeObjectURL(objectUrl);
            });
    }

    return <button className={`btn btn-secondary ${extraClass}`} type="button"  onClick={handleDownload}>
        Download PDF
    </button>
}

export default DownloadAdmissionDocumentPdf;